function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 32v-32h64v64h-64",
  fill: "#007acc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.032 32.112v2.608h8.32v23.68h5.904v-23.68h8.32v-2.56c0-1.44 0-2.608-.064-2.64 0-.048-5.072-.064-11.232-.064l-11.2.048v2.624zm37.392-2.672c1.632.384 2.88 1.12 4 2.288.592.64 1.472 1.76 1.536 2.048 0 .096-2.768 1.968-4.448 3.008-.064.048-.32-.224-.576-.64-.832-1.184-1.68-1.696-3.008-1.792-1.92-.128-3.2.88-3.2 2.56 0 .512.096.8.288 1.216.432.88 1.232 1.408 3.712 2.496 4.576 1.968 6.56 3.264 7.76 5.12 1.36 2.08 1.664 5.344.752 7.792-1.024 2.672-3.52 4.48-7.088 5.072-1.12.192-3.68.16-4.88-.048-2.56-.48-5.008-1.76-6.512-3.408-.592-.64-1.728-2.352-1.664-2.464l.608-.384 2.4-1.392 1.808-1.056.416.56c.528.832 1.712 1.952 2.4 2.336 2.08 1.072 4.864.928 6.24-.32.592-.544.848-1.12.848-1.92 0-.736-.112-1.072-.48-1.632-.512-.704-1.536-1.28-4.416-2.56-3.312-1.408-4.72-2.304-6.032-3.68-.752-.832-1.44-2.128-1.76-3.2-.24-.928-.32-3.2-.096-4.112.688-3.2 3.104-5.44 6.56-6.08 1.12-.224 3.76-.128 4.864.16z",
  fill: "#fff"
}));

function SvgIconTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypescript);
export default __webpack_public_path__ + "static/media/icon-typescript.2c993acb.svg";
export { ForwardRef as ReactComponent };